import * as _ from 'lodash';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Switch, matchPath } from 'react-router-dom';

import RoutePrivate from '../router/RoutePrivate';

import { Card } from '@blueprintjs/core';

import ProjectNavBar from './ProjectNavBar';
import CardContainer from 'src/components/common/CardContainer';
import Project from 'src/models/Project';

import Sections from './sections';
import ProjectStaffing from 'src/components/project/sections/StaffingPage';
import { UserRoles } from 'src/models/UserRole';
// import TractsPage from './sections/Tract';
// import TagsPage from './sections/TagsPage';
import TractsPage from './sections/Tract.redesign';
import UserDetails from 'src/models/UserDetails';

import TractDetail from './sections/TractComponents/TractDetail';
// import TractDetail from './sections/TractComponents/TractDetail.redesign';
import TractDashboard from './sections/Dashboard';
import OwnersPage from './sections/OwnersPage';
// import LeaseInfo from './sections/TractComponents/LeaseInfo';
import LeaseInfo from './sections/TractComponents/LeaseholdInfoComponents/LeaseInfo.redesign';
import Leasing from './sections/LeasingComponents/Leasing';
import LeaseGeneration from './sections/LeasingComponents/redesign/LeaseGeneration.redesign';
import { IRootState } from 'src/reducers';
import selectors from 'src/selectors';
import actions from 'src/actions';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import EditOwnerPage from './sections/owners/EditOwnerPage';
import BreadCrumb from '../common/BreadCrumb';
import SurfaceTractPage from './sections/SurfaceTractPage';
import RightOfWayInfo from './sections/TractComponents/LeaseholdInfoComponents/RightOfWayInfo';
import SurfaceWaiverInfo from './sections/TractComponents/LeaseholdInfoComponents/SurfaceWaiverInfo';
import SolarLeaseInfo from './sections/TractComponents/LeaseholdInfoComponents/SolarLeaseInfo';
import BatteryStorageInfo from './sections/TractComponents/LeaseholdInfoComponents/BatteryStorageInfo';
import SearchPanel from '../common/SearchPanel';
import SearchListData from 'src/models/SearchListData';
import ContractGenerationPage from './sections/LeasingComponents/redesign/ContractGenerationComponents/ContractGenerationPage';
import BrineLeaseInfo from './sections/TractComponents/LeaseholdInfoComponents/BrineLeaseInfo';
import ProcessingAndMaintenance from './sections/TractComponents/ProcessingAndMaintenance/ProcessingAndMaintenance';
import CarbonCaptureInfo from './sections/TractComponents/LeaseholdInfoComponents/CarbonCaptureInfo';

interface IProjectDetailPageStateProps {
    isLoggedIn: boolean;
    projectIsLoading: boolean;
    user: UserDetails;
    project: (clientId: number, projectId: number) => Project;
    testMode: boolean;
}

interface IProjectDetailLocalStateProps {
    isRealVisible: boolean;
    filterData: SearchListData[];
    filterTownships: boolean;
    filterTracts: boolean;
    refreshTags: boolean;
    showPanel: boolean;
    isCollapsed: boolean;
}

export interface IProjectDetailPageDispatchProps {
    getProject: (clientId: number, projectId: number) => void;
    navigate: (path: string) => void;
    initializeTractPage: () => void;
}

type IProjectDetailPageProps = RouteComponentProps<{
    clientNumber?: string;
    projectNumber?: string;
}> &
    IProjectDetailPageStateProps &
    IProjectDetailPageDispatchProps &
    IProjectDetailLocalStateProps;

class ProjectDetailPage extends React.Component<IProjectDetailPageProps, IProjectDetailLocalStateProps> {
    constructor(props: IProjectDetailPageProps) {
        super(props);

        this.state = {
            isRealVisible: true,
            filterData: [],
            filterTownships: false,
            filterTracts: true,
            refreshTags: false,
            showPanel: false,
            isCollapsed: false,
        };

        this.projectHeader = this.projectHeader.bind(this);
    }

    private clientNumber: number;

    componentDidMount() {
        this.clientNumber = parseInt(this.props.match.params.clientNumber, 10);
        this.props.getProject(parseInt(this.props.match.params.clientNumber, 10), parseInt(this.props.match.params.projectNumber, 10));
    }

    show = () => {
        this.setState({ isRealVisible: false });
        setTimeout(this.unShow, 2000);
    };
    unShow = () => {
        this.setState({ isRealVisible: true });
    };

    setFilterTownships = (toFilterTownships: boolean) => {
        let filterTs = toFilterTownships;
        this.setState({filterTownships: filterTs});
    }

    setRefreshTags = () => {
        this.setState({refreshTags: !this.state.refreshTags});
    }

    setShowPanel = (show: boolean) => {
        this.setState({showPanel: show});
    }

    setFilterTracts = (toFilterTracts: boolean) => {
        let filterTts = toFilterTracts;
        this.setState({filterTracts: filterTts});
    }

    displayedClientName = (project: Project) => {
        if (project && project.client && project.client.cloakName) {
            return project.client.cloakName;
        } else if (project) {
            return project.client.name;
        } else {
            return 'Client';
        }
    };

    displayedProjectName = (project: Project) => {
        if (project && project.client && project.client.isShadow && project.cloakName) {
            return `${project.cloakName} (${project.cloakProjectNumber})`;
        } else if (project && project.name) {
            return `${project.name}`;
        } else {
            return 'Project';
        }
    };

    private projectHeader() {
        const project = this.props.project(parseInt(this.props.match.params.clientNumber, 10), parseInt(this.props.match.params.projectNumber, 10));

        const clientName = this.displayedClientName(project);
        const projectName = this.displayedProjectName(project);

        return (
            <>
                <div className="card-header" style={{ padding: '0px' }}>
                    {/* <span style={{ padding: '.2rem 1rem' }}>{`${this.clientNumber}-${project?.projectNumber}`}</span>
                    <span style={{ padding: '.2rem 1rem' }}>{clientName}</span>&middot;
                    <span style={{ padding: '.2rem 1rem' }}>{projectName}</span>&middot; */}
                    <BreadCrumb clientName={clientName} clientNumber={this.clientNumber} projectName={projectName} />
                    {/* <span style={{ padding: '.2rem 1rem' }}>{projectTypeName}</span> */}
                </div>
            </>
        );
    }

    private updateFilterData = (filterData: SearchListData[]) => {
        this.setState({ filterData: filterData});
    }

    private filterPanel() {
        return (
            <div className="tag-filter" style={{ zIndex: 1000, position: 'fixed', display: 'flex', width: '13%' }}>
                <SearchPanel
                    updateFilterString={this.updateFilterData}
                    filterTownshipsCallback={this.setFilterTownships}
                    filterTractsCallback={this.setFilterTracts}
                    updateTags={this.state.refreshTags}
                />
            </div>
        );
    }

    private toggleHeader(value: boolean) {
        this.setState({ isCollapsed: value });
        localStorage.setItem('isCollapsed', value.toString());
    }

    public render() {
        const isCollapsed = this.state.isCollapsed;

        const isWideRoute = matchPath(this.props.location.pathname, {
            path: this.props.match.path + '/mapping',
            exact: true,
            strict: false
        }) || 
        matchPath(this.props.location.pathname, {
            path: this.props.match.path + '/acquisitions/lease-generation',
            exact: false,
            strict: false
        }) || 
        matchPath(this.props.location.pathname, {
            path: this.props.match.path + '/sections/:sectionNumber/surface-tracts',
            exact: false,
            strict: false
        }) || 
        matchPath(this.props.location.pathname, {
            path: this.props.match.path + '/sections/:sectionNumber/tracts',
            exact: false,
            strict: false
        }) || 
        matchPath(this.props.location.pathname, {
            path: this.props.match.path + '/maps/:mapNumber/tracts',
            exact: false,
            strict: false
        }) || 
        matchPath(this.props.location.pathname, {
            path: this.props.match.path + '/maps/:mapNumber/surface-tracts',
            exact: false,
            strict: false
        });

        return (
            <>
            {this.state.showPanel && this.filterPanel()}
                <CardContainer className={isWideRoute ? isCollapsed ? 'lh-card-container-wide-tall' : 'lh-card-container-wide' : 'lh-card-container'}>
                    <Card elevation={1} className="lh-no-padding-card">
                        {isCollapsed && 
                            <div className="project-nav-bar" style={{ width: '100%' }}>
                                <div 
                                    style={{ marginLeft: 'auto' }}
                                    className="sub-nav-menu-item" 
                                    onClick={() => this.toggleHeader(false)} 
                                >
                                    <span>Expand <i style={{ fontSize: '1.2rem' }} className="far fa-angle-double-down mr-1" /></span>
                                </div>
                            </div>
                        }
                        {!isCollapsed && <div className="card-section" style={{ padding: '8px 20px', backgroundColor: '#EEF2F5' }}>
                            {this.projectHeader()}
                        </div>}
                        {!isCollapsed && <ProjectNavBar
                            matchUrl={this.props.match.url}
                            location={this.props.location.pathname}
                            navigate={this.props.navigate}
                            user={this.props.user}
                            currentProject={this.props.project(
                                parseInt(this.props.match.params.clientNumber, 10),
                                parseInt(this.props.match.params.projectNumber, 10)
                            )}
                            testMode={this.props.testMode}
                            onClick={this.props.initializeTractPage}
                            collapseHeader={() => this.toggleHeader(true)}
                        />}
                        <Switch>
                            <RoutePrivate
                                key="lease-info"
                                path={
                                    this.props.match.path +
                                    '/sections/:sectionNumber/tracts/:tractNumber/horizons/:horizonNumber/ownership/:ownershipId/leases/:leaseId'
                                }
                                component={LeaseInfo}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                            <RoutePrivate
                                key="lease-info"
                                path={
                                    this.props.match.path +
                                    '/maps/:sectionNumber/tracts/:tractNumber/horizons/:horizonNumber/ownership/:ownershipId/leases/:leaseId'
                                }
                                component={LeaseInfo}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                            <RoutePrivate
                                key="lease-info-for-surface"
                                path={
                                    this.props.match.path +
                                    '/sections/:sectionNumber/surface-tracts/:surfaceTractNumber/ownership/:ownershipId/leases/:leaseId'
                                }
                                component={LeaseInfo}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                            <RoutePrivate
                                key="surface-waiver-info"
                                path={
                                    this.props.match.path +
                                    '/sections/:sectionNumber/tracts/:tractNumber/horizons/:horizonNumber/ownership/:ownershipId/surface-waivers/:surfaceWaiverNumber'
                                }
                                component={SurfaceWaiverInfo}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                            <RoutePrivate
                                key="surface-waiver-info"
                                path={
                                    this.props.match.path +
                                    '/sections/:sectionNumber/surface-tracts/:surfaceTractNumber/ownership/:ownershipId/surface-waivers/:surfaceWaiverNumber'
                                }
                                component={SurfaceWaiverInfo}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                            <RoutePrivate
                                key="solar-lease-info"
                                path={
                                    this.props.match.path +
                                    '/sections/:sectionNumber/tracts/:tractNumber/horizons/:horizonNumber/ownership/:ownershipId/solar-leases/:solarLeaseNumber'
                                }
                                component={SolarLeaseInfo}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                            <RoutePrivate
                                key="solar-lease-info-for-surface"
                                path={
                                    this.props.match.path +
                                    '/sections/:sectionNumber/surface-tracts/:surfaceTractNumber/ownership/:ownershipId/solar-leases/:solarLeaseNumber'
                                }
                                component={SolarLeaseInfo}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                            <RoutePrivate
                                key="brine-lease-info"
                                path={
                                    this.props.match.path +
                                    '/sections/:sectionNumber/tracts/:tractNumber/horizons/:horizonNumber/ownership/:ownershipId/brine-leases/:brineLeaseNumber'
                                }
                                component={BrineLeaseInfo}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                            <RoutePrivate
                                key="brine-lease-info-for-surface"
                                path={
                                    this.props.match.path +
                                    '/sections/:sectionNumber/surface-tracts/:surfaceTractNumber/ownership/:ownershipId/brine-leases/:brineLeaseNumber'
                                }
                                component={BrineLeaseInfo}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                            <RoutePrivate
                                key="right-of-way-info"
                                path={
                                    this.props.match.path +
                                    '/sections/:sectionNumber/tracts/:tractNumber/horizons/:horizonNumber/ownership/:ownershipId/right-of-ways/:rightOfWayNumber'
                                }
                                component={RightOfWayInfo}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                            <RoutePrivate
                                key="right-of-way-info-for-surface"
                                path={
                                    this.props.match.path +
                                    '/sections/:sectionNumber/surface-tracts/:surfaceTractNumber/ownership/:ownershipId/right-of-ways/:rightOfWayNumber'
                                }
                                component={RightOfWayInfo}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                            <RoutePrivate
                                key="battery-storage-info"
                                path={
                                    this.props.match.path +
                                    '/sections/:sectionNumber/tracts/:tractNumber/horizons/:horizonNumber/ownership/:ownershipId/battery-storage/:batteryStorageNumber'
                                }
                                component={BatteryStorageInfo}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                            <RoutePrivate
                                key="battery-storage-info-for-surface"
                                path={
                                    this.props.match.path +
                                    '/sections/:sectionNumber/surface-tracts/:surfaceTractNumber/ownership/:ownershipId/battery-storage/:batteryStorageNumber'
                                }
                                component={BatteryStorageInfo}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                            <RoutePrivate
                                key="carbon-capture-info"
                                path={
                                    this.props.match.path +
                                    '/sections/:sectionNumber/tracts/:tractNumber/horizons/:horizonNumber/ownership/:ownershipId/carbon-captures/:carbonCaptureNumber'
                                }
                                component={CarbonCaptureInfo}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                            <RoutePrivate
                                key="carbon-capture-info-for-surface"
                                path={
                                    this.props.match.path +
                                    '/sections/:sectionNumber/surface-tracts/:surfaceTractNumber/ownership/:ownershipId/carbon-captures/:carbonCaptureNumber'
                                }
                                component={CarbonCaptureInfo}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                            <RoutePrivate
                                key="project-tract-detail"
                                path={this.props.match.path + '/sections/:sectionNumber/tracts/:tractNumber/horizons/:horizonNumber'}
                                component={TractDetail}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                            <RoutePrivate
                                key="project-surface-tract-detail"
                                path={this.props.match.path + '/sections/:sectionNumber/surface-tracts/:surfaceTractNumber'}
                                component={SurfaceTractPage}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                            <RoutePrivate
                                key="project-create-tract-detail"
                                path={this.props.match.path + '/sections/:sectionNumber/create-tract'}
                                component={TractDetail}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                            <RoutePrivate
                                key="project-tract-detail-eastern"
                                path={this.props.match.path + '/maps/:mapNumber/tracts/:tractNumber/horizons/:horizonNumber'}
                                component={TractDetail}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                            <RoutePrivate
                                key="project-create-tract-detail-eastern"
                                path={this.props.match.path + '/maps/:mapNumber/create-tract'}
                                component={TractDetail}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                            <RoutePrivate
                                key="project-tracts"
                                path={[this.props.match.path + '/tracts', this.props.match.path + '/sections/:sectionNumber/tracts', this.props.match.path + '/maps/:mapNumber/tracts']}
                                component={TractsPage}
                                isLoggedIn={this.props.isLoggedIn}
                                user={this.props.user}
                                roles={[UserRoles.Admin]}
                                searchFilterData={this.state.filterData}
                                filterTownships={this.state.filterTownships}
                                filterTracts={this.state.filterTracts}
                                refreshTags={this.setRefreshTags}
                                showPanel={this.setShowPanel}
                            />
                            {/* Leaving this here in case we want to revisit the tag management page.
                            <RoutePrivate
                                key="project-tags"
                                path={[this.props.match.path + '/tags', this.props.match.path + '/tags']}
                                component={TagsPage}
                                isLoggedIn={this.props.isLoggedIn}
                                user={this.props.user}
                                roles={[UserRoles.Admin]}
                            />
                            */}

                            {/* <RoutePrivate
                key="project-sections-tracts"
                path={this.props.match.path + '/sections/:sectionNumber/tracts'}
                component={TractsPage}
                isLoggedIn={this.props.isLoggedIn}
                user={this.props.user}
                roles={[UserRoles.Admin]}
            /> */}
                            <RoutePrivate
                                key="edit-owner"
                                exact={true}
                                path={this.props.match.path + '/owners/:ownerId/edit'}
                                component={EditOwnerPage}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                            <RoutePrivate
                                key="project-owners"
                                exact={true}
                                path={this.props.match.path + '/owners'}
                                component={OwnersPage}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                            <RoutePrivate
                                key="project-leasing-lease-generation"
                                path={this.props.match.path + '/acquisitions/lease-generation/ownerId/:ownerId/leases/:leaseFormId'}
                                component={LeaseGeneration}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                            <RoutePrivate
                                key="project-leasing-solar-lease-generation"
                                path={this.props.match.path + '/acquisitions/lease-generation/ownerId/:ownerId/solar-leases/:solarLeaseFormId'}
                                component={ContractGenerationPage}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                            <RoutePrivate
                                key="project-leasing-surface-waiver-generation"
                                path={this.props.match.path + '/acquisitions/lease-generation/ownerId/:ownerId/surface-waivers/:surfaceWaiverFormId'}
                                component={ContractGenerationPage}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                            <RoutePrivate
                                key="project-leasing-battery-storage-generation"
                                path={this.props.match.path + '/acquisitions/lease-generation/ownerId/:ownerId/battery-storage/:batteryStorageFormId'}
                                component={ContractGenerationPage}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                            <RoutePrivate
                                key="project-leasing-brine-lease-generation"
                                path={this.props.match.path + '/acquisitions/lease-generation/ownerId/:ownerId/brine-leases/:brineLeaseFormId'}
                                component={ContractGenerationPage}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                            <RoutePrivate
                                key="project-leasing-right-of-way-generation"
                                path={this.props.match.path + '/acquisitions/lease-generation/ownerId/:ownerId/right-of-ways/:rightOfWayFormId'}
                                component={ContractGenerationPage}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                            <RoutePrivate
                                key="project-leasing-carbon-capture-generation"
                                path={this.props.match.path + '/acquisitions/lease-generation/ownerId/:ownerId/carbon-captures/:rightOfWayFormId'}
                                component={ContractGenerationPage}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                            <RoutePrivate
                                key="project-acquisitions"
                                path={this.props.match.path + '/acquisitions'}
                                component={Leasing}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                            <RoutePrivate
                                key="project-mapping"
                                path={this.props.match.path + '/mapping'}
                                component={Sections.Mapping}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                            <RoutePrivate
                                key="project-documents"
                                path={this.props.match.path + '/documents'}
                                component={Sections.Documents}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                            <RoutePrivate
                                key="project-third-party-leases"
                                path={this.props.match.path + '/third-party-leases'}
                                component={Sections.ThirdPartyLeases}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                            <RoutePrivate
                                key="project-reports"
                                path={this.props.match.path + '/reports/:reportId'}
                                component={Sections.ReportDetail}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                            <RoutePrivate
                                key="project-reports"
                                path={this.props.match.path + '/reports'}
                                component={Sections.Reports}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                            <RoutePrivate
                                key="project-runsheets"
                                path={this.props.match.path + '/runsheets'}
                                component={Sections.RunsheetPage}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                            <RoutePrivate
                                key="project-runsheet-detail"
                                path={this.props.match.path + '/runsheets/:runSheetId'}
                                component={Sections.RunsheetDetail}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                            <RoutePrivate
                                key="project-staffing"
                                path={this.props.match.path + '/staffing'}
                                component={ProjectStaffing}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                            <RoutePrivate
                                key="project-settings"
                                path={this.props.match.path + '/settings'}
                                component={Sections.Settings}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                            <RoutePrivate
                                key="processing-and-maintenance"
                                path={this.props.match.path + '/processing'}
                                component={ProcessingAndMaintenance}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                            <RoutePrivate
                                key="project-dashboard"
                                path={this.props.match.path + '/'}
                                component={TractDashboard}
                                isLoggedIn={this.props.isLoggedIn}
                            />
                        </Switch>
                    </Card>
                </CardContainer>
            </>
        );
    }
}

const mapStateToProps = (state: IRootState) => ({
    isLoggedIn: selectors.auth.isLoggedIn(state),
    projectIsLoading: selectors.project.isLoading(state),
    user: selectors.auth.user(state),
    project: (clientId: number, projectId: number) => selectors.project.project(clientId, projectId)(state),
    testMode: state.layout.testingMode,
});

const mapDispatchToProps: IProjectDetailPageDispatchProps = {
    getProject: (clientId: number, projectId: number) => actions.project.getProject(clientId, projectId),
    navigate: (path: string) => push(path),
    initializeTractPage: () => actions.tract.initTractPage(),
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectDetailPage);



// WEBPACK FOOTER //
// ./src/components/project/ProjectDetailPage.tsx